import { useEffect, useState, useCallback } from 'react';
import { throttle } from '../../../../utils/throttle';
const PROGRESS_CALCULATION_INTERVAL = 250;
export const useLabProgress = (virtualMachines) => {
    const [importProgress, setImportProgress] = useState(0);
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [vmDownloadProgress, setVMDownloadProgress] = useState();
    const [vmImportProgress, setVMImportProgress] = useState();
    const [namesToCIDs, setNamesToCIDs] = useState();
    useEffect(() => {
        if (!virtualMachines)
            return;
        const { importSize, downloadSize } = virtualMachines.reduce((prev, currVM) => {
            prev.importSize += currVM.sizeMB;
            //keep track of whether or not we're accounting for that cid size already or not
            if (!prev.cids[currVM.cid]) {
                prev.cids[currVM.cid] = true;
                prev.downloadSize += currVM.sizeMB;
            }
            return prev;
        }, { importSize: 0, cids: {}, downloadSize: 0 });
        const { importProgress, downloadProgress } = virtualMachines.reduce((prev, currVM) => {
            prev.importProgress[currVM.name] = {
                progress: 0,
                weight: currVM.sizeMB / importSize
            };
            prev.downloadProgress[currVM.cid] = {
                progress: 0,
                weight: currVM.sizeMB / downloadSize
            };
            setNamesToCIDs((prev) => {
                prev = prev !== null && prev !== void 0 ? prev : {};
                const { name, cid } = currVM;
                prev[name] = cid;
                return Object.assign({}, prev);
            });
            return prev;
        }, { importProgress: {}, downloadProgress: {} });
        setVMDownloadProgress(downloadProgress);
        setVMImportProgress(importProgress);
    }, [virtualMachines]);
    const calculateProgress = useCallback((individualProgress, setTotalProgress) => {
        const progress = Object.values(individualProgress).reduce((prev, { progress, weight }) => {
            prev += progress * weight;
            return prev;
        }, 0);
        setTotalProgress(progress);
    }, []);
    const throttledCalculateProgress = useCallback((progress, setTotalProgress) => {
        const calculate = throttle(calculateProgress, PROGRESS_CALCULATION_INTERVAL);
        calculate(progress, setTotalProgress);
    }, [calculateProgress]);
    useEffect(() => {
        if (!vmDownloadProgress)
            return;
        throttledCalculateProgress(vmDownloadProgress, setDownloadProgress);
    }, [vmDownloadProgress, throttledCalculateProgress]);
    useEffect(() => {
        if (!vmImportProgress)
            return;
        throttledCalculateProgress(vmImportProgress, setImportProgress);
    }, [vmImportProgress, throttledCalculateProgress]);
    const onVMImageDownloadProgress = (event) => {
        console.log(`Image download progress: ${event.cid}: ${event.progressPercentage}`);
        setVMDownloadProgress((prev) => {
            prev = prev !== null && prev !== void 0 ? prev : {};
            prev[event.cid] = Object.assign(Object.assign({}, prev[event.cid]), { progress: event.progressPercentage });
            return Object.assign({}, prev);
        });
    };
    const onVMImportProgress = (event) => {
        console.log(`Import progress: ${event.name}: ${event.progressPercentage}`);
        const vmCid = namesToCIDs ? namesToCIDs[event.name] : null;
        //if the user refreshes the page, download progress will be lost, but if we get an import event we can assume DL progress is 100
        if (vmCid && vmDownloadProgress && vmDownloadProgress[vmCid] && vmDownloadProgress[vmCid].progress !== 100) {
            setVMDownloadProgress((prev) => {
                prev = prev !== null && prev !== void 0 ? prev : {};
                prev[vmCid] = Object.assign(Object.assign({}, prev[vmCid]), { progress: 100 });
                return Object.assign({}, prev);
            });
        }
        setVMImportProgress((prev) => {
            prev = prev !== null && prev !== void 0 ? prev : {};
            prev[event.name] = Object.assign(Object.assign({}, prev[event.name]), { progress: event.progressPercentage });
            return Object.assign({}, prev);
        });
    };
    return {
        onVMImportProgress,
        onVMImageDownloadProgress,
        setImportProgress,
        setDownloadProgress,
        importProgress,
        downloadProgress
    };
};
//# sourceMappingURL=useLabProgress.js.map